import { viewStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsView";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";
// EC-617 : Fixing css issues on PLP & PDP
viewStyles.container = {
    css: css`
        direction: rtl;
        max-width: 100% !important;
        > div[class^="GridOffset"] {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        margin: 0px;
                        flex-direction: column-reverse;
                        align-items: center;
                        width: 100%;
                    `,

                    null,

                    null,
                ])}
        }
        div [data-test-selector="cart_pickUpLocation"] {
            p[data-test-selector="cart_warehouseName"] {
                font-size: 12px;
            }
            address[data-test-selector="addressInfoDisplay"] {
                p {
                    font-size: 12px;
                }

                > div {
                    margin-bottom: 20px;
                    padding-top: 10px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                margin: 20px 0px;
                            `,
                            css`
                                margin: 20px 0px;
                            `,
                            css`
                                margin: 20px 0px;
                            `,
                            null,
                            null,
                        ])}
                }
            }
        }
        span[data-test-selector="productPrice_unitNetPrice"] {
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
        }
        label[data-test-selector="product_qtyOrdered-label"] {
            font-size: 12px;
            font-weight: normal;
        }
    `,
};
